export const SOCIAL_EMBED_MODAL = 'socialEmbedUploadModal';
export const SOCIAL_EMBED_MODAL_INPUT = 'socialEmbedUploadModalInput';
export const SOCIAL_EMBED_MODAL_SUBMIT_BTN = 'actionButtonSave';
export const TOOLBAR_BUTTON_REPLACE_TO_LINK = 'baseToolbarButton_replaceToLink';
